export default `vec3 Q = fract(p)-.5;
    for(int j=0;j++<5;){
      Q=abs(Q)-.17;
      if(Q.y>Q.x)
        Q.xy=Q.yx;
      if(Q.z>Q.y)
        Q.yz=Q.zy;
      Q.z=abs(Q.z);
      Q-=.17;
      Q*=3.;
    }
    return max((length(Q)-.9)/3e2,1.37-length(p.xy));
  }`